import React, { useEffect, useState } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  Typography,
  CardMedia,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";
import { getData, storeData } from "../../utils/GlobalHelper";
import { isMobile } from "react-device-detect";
const Index = (props) => {
  const { comeback, clickBack, title, onChangeLang } = props;
  const [IconLang, setIconLang] = useState();
  const [lang, setLang] = useState(getData("lang") ? getData("lang") : "th");

  const [anchorEl, setAnchorEl] = useState(null);
  const [IconSwitch, setIconSwitch] = useState("../../../images/down.png");

  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setIconSwitch("../../../images/up.png");
  };
  const handleClose = (e) => {
    if (e.target.innerText) {
      storeData("lang", e.target.innerText.toLowerCase());
      setLang(getData("lang"));
    }
    setAnchorEl(null);
    setIconSwitch("../../../images/down.png");
  };

  useEffect(() => {
    if (lang === "en") {
      setIconLang("../../../images/en.svg");
    } else {
      setIconLang("../../../images/th.svg");
    }
    onChangeLang(lang);
  }, [lang]);
  return (
    <>
      <AppBar position="static" color="inherit">
        <Toolbar>
          {!isMobile ? (
            <>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                <CardMedia
                  component="img"
                  sx={{ width: 151 }}
                  image="../../images/logo.png"
                  alt="logo"
                />
              </Typography>
              <Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  onClick={handleMenu}
                >
                  <Grid item>
                    <Avatar
                      sx={{ bgcolor: "var(--white)", width: 25 }}
                      aria-label="recipe"
                    >
                      <CardMedia component="img" image={IconLang} alt="Lang" />
                    </Avatar>
                  </Grid>
                  <Grid item>
                    <Typography variant="h6" component="div">
                      {lang.toUpperCase()}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <CardMedia
                      component="img"
                      sx={{ width: 10 }}
                      image={IconSwitch}
                      alt="IconSwitch"
                    />
                  </Grid>
                </Grid>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClick={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem
                    value="th"
                    className="font-title font-16 text-primary"
                  >
                    TH
                  </MenuItem>
                  <MenuItem
                    value="en"
                    className="font-title font-16 text-primary"
                  >
                    EN
                  </MenuItem>
                </Menu>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={1}>
                  {!comeback && (
                    <CardMedia
                      component="img"
                      sx={{ width: 20 }}
                      image="../../../images/back.png"
                      alt="back"
                      onClick={() => {
                        clickBack(true);
                      }}
                    />
                  )}
                </Grid>
                <Grid item xs={10}>
                  <Typography className="font-title text-center">
                    {title}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <CardMedia
                    component="img"
                    sx={{ width: 30 }}
                    image="../../../favicon.ico"
                    alt="back"
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};
export default Index;
